(() => {
  const launcher = document.querySelector('[data-zendesk-launcher]');
  if (!launcher || document.getElementById('ze-snippet')) return;

  let loading = false;

  const openMessenger = () => {
    if (typeof window.zE === 'function') {
      window.zE('messenger', 'open');
    }
  };

  launcher.addEventListener('click', () => {
    if (loading) return;
    loading = true;
    launcher.disabled = true;
    launcher.setAttribute('aria-busy', 'true');

    const script = document.createElement('script');
    script.id = 'ze-snippet';
    script.src = 'https://static.zdassets.com/ekr/snippet.js?key=6943ab4c-5ab7-4a46-9448-c220502f056c';
    script.async = true;
    script.onload = () => {
      launcher.remove();
      window.setTimeout(openMessenger, 250);
    };
    script.onerror = () => {
      loading = false;
      launcher.disabled = false;
      launcher.removeAttribute('aria-busy');
    };
    document.head.appendChild(script);
  });
})();
